
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { RootState } from '@/store';
import { setSportsCategories } from '@/store/slices/turfSlice';
import { venueUpdateById, getStaticConfig } from '@/store/thunkMidddleware/turfMiddleware';
import SPORTS_CATEGORIESSkeleton from '@/components/skeletons/VenueDetailSkeleton';
import Strings from '@/constants/String';
import { ButtonWithLoader } from '../ui/buttonwithloader';
import { toast as newToast } from "@/components/ui/sonner";

interface SportsCategoriesFormProps {
  onNext: () => void;
  onBack: () => void;
  showActions?:boolean;
  selectedCategoriesFromProps?:string[]
  setSelectedCategoriesFromProps?:any
  setIsCategoriesFormInputChanged?:any
}

const SportsCategoriesForm: React.FC<SportsCategoriesFormProps> = ({ onNext, onBack ,showActions=true,setSelectedCategoriesFromProps=null,setIsCategoriesFormInputChanged}) => {
  const dispatch = useAppDispatch();
  const { sportsCategories, currentOnboardVenueDetails, staticConfigResponse, venueUpdateByIdResponse } = useAppSelector((state: RootState) => state.turf);
  const { toast } = useToast();
  const [isFormInputChanged, setIsFormInputChanged] = useState(false)

  const [selectedCategories, setSelectedCategories] = useState<string[]>(sportsCategories);

  useEffect(() => {
    setSelectedCategories(sportsCategories)
    if(setSelectedCategoriesFromProps){
      setSelectedCategoriesFromProps(sportsCategories)

    }
  }, [sportsCategories])

  const handleCategoryChange = (category: string, checked: boolean) => {
    setIsFormInputChanged(true)
    if(setIsCategoriesFormInputChanged){
      setIsCategoriesFormInputChanged(true)
    }
    if (checked) {
      setSelectedCategories(prev => [...prev, category]);
      if(setSelectedCategoriesFromProps){

      setSelectedCategoriesFromProps(prev => [...prev, category]);
      }
    } else {
      setSelectedCategories(prev => prev.filter(c => c !== category));
      if(setSelectedCategoriesFromProps){
        setSelectedCategoriesFromProps(prev => prev.filter(c => c !== category));

      }

    }
  };

  const handleSubmit = () => {
    if (selectedCategories.length === 0) {
      toast({ title: 'Error', description: 'Please select at least one sports category', variant: 'destructive' });
      return;
    }

    if (isFormInputChanged) {


      setIsFormInputChanged(false)
      if(setIsCategoriesFormInputChanged){
        setIsCategoriesFormInputChanged(false)
      }
      dispatch(setSportsCategories(selectedCategories));

      if (currentOnboardVenueDetails?.payload?._id) {
        updateVenue(currentOnboardVenueDetails?.payload?._id, (res) => {
          onNext();
        })
      } else {
        toast({ title: 'Error', description: 'Venue id required' });
      }
    } else {
      // toast({ title: 'Success', description: 'Nothing modified!' });
      newToast.success('Nothing modified!', { closeButton: true })
      onNext();
    }
  }



  const updateVenue = (venueId: String, cb: (res: any) => void) => {
    if (venueId) {
      dispatch(venueUpdateById({
        payload: { sportsCategories: selectedCategories }, venueId: venueId, callback: (res) => {
          console.log("venueUpdateById sportsCategories:", res)
          if (cb) {
            cb(res)
          }
        }
      }))
    }
  }

  useEffect(() => {
    dispatch(getStaticConfig({ pathparams: Strings.staticConfigKeys.sportsTypes }))
  }, [])

  if (staticConfigResponse.isLoading) {
    return <SPORTS_CATEGORIESSkeleton />
  }

  return (
    // <div className="min-h-screen bg-flup-canvas p-4 flex items-center justify-center">
    <div className="flex items-start justify-center">

      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Sports Categories</CardTitle>
          <CardDescription>Select the sports available at your turf</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {staticConfigResponse?.payload?.key === Strings.staticConfigKeys.sportsTypes &&
              staticConfigResponse?.payload?.values?.map((category) => (
              <div key={category} className="flex items-center space-x-2 p-2 border rounded-lg hover:bg-flup-surface-alt">
                <Checkbox
                  id={category}
                  checked={selectedCategories.includes(category)}
                  onCheckedChange={(checked) => handleCategoryChange(category, checked as boolean)}
                />
                <Label htmlFor={category} className="cursor-pointer font-medium">
                  {category}
                </Label>
              </div>
            ))}
          </div>

          <div className="bg-flup-info-soft p-4 rounded-lg">
            <h3 className="font-semibold text-blue-800 mb-2">Selected Categories ({selectedCategories.length})</h3>
            <div className="flex flex-wrap gap-2">
              {selectedCategories.map((category) => (
                <span key={category} className="bg-flup-info-soft text-blue-800 px-3 py-1 rounded-full text-sm">
                  {category}
                </span>
              ))}
            </div>
          </div>

         {showActions && <div className="flex gap-4 pt-4">
            <Button
              disabled={venueUpdateByIdResponse.isLoading}
              variant="outline"
              onClick={onBack}
              className="flex-1"
            >
              Back
            </Button>

            <ButtonWithLoader
              loaderPosition='right'
              isLoading={venueUpdateByIdResponse.isLoading}
              onClick={handleSubmit}
              className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white"
              disabled={venueUpdateByIdResponse.isLoading}
            >
              Continue
            </ButtonWithLoader>
          </div>}
        </CardContent>
      </Card>
    </div>
  );
};

export default SportsCategoriesForm;
